import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { getStaticCDN } from '@design-system/utils/utils';

const img375 = getStaticCDN(`/assets/shared/sell-car/stats-375.svg`);
const img576 = getStaticCDN(`/assets/shared/sell-car/stats-576.svg`);
const img768 = getStaticCDN(`/assets/shared/sell-car/stats-768.svg`);
const img992 = getStaticCDN(`/assets/shared/sell-car/stats-992.svg`);
const img1280 = getStaticCDN(`/assets/shared/sell-car/stats-1280.svg`);

const StyledWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  padding: 55px 0 315px;
  height: 607px;
  background: ${(props) => props.theme.color.surface} url('${img375}') no-repeat;
  background-position-y: bottom;
  background-position-x: left;

  .price-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    height: 100%;
    max-width: 80%;
    max-height: 264px;
    margin-right: 20px;
    padding-left: 11px;
    right: 0;
    top: 37px;
    border-left: 1.2px solid ${(props) => props.theme.color.primaryBase};

    .price-amount {
      font-weight: 700;
      font-size: 20px;
      line-height: 20px;
      color: ${(props) => props.theme.color.primaryBase};
      ${(props) => props.theme.typo.familyGoogle.bold};
      > span:first-child {
        font-size: 14px;
      }
    }

    .price-text {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: ${(props) => props.theme.color.onBackgroundMediumEmphasis};
      max-width: 200px;
      ${(props) => props.theme.typo.familyGoogle.semiBold};
    }

    @media screen and (min-width: 576px) {
      right: 80px;
    }

    @media screen and (min-width: 768px) {
      position: static;
      max-height: 330px;
      height: 100%;
      width: auto;
      margin: auto;
      .price-amount {
        font-size: 28px;
        line-height: 28px;
        > span:first-child {
          font-size: 20px;
        }
      }
      .price-text {
        font-size: 20px;
      }
    }
    @media screen and (min-width: 1280px) {
      max-width: 60%;
    }
    @media screen and (min-width: 1800px) {
      max-width: 1024px;
    }
  }

  @media screen and (min-width: 576px) {
    background-position-x: center;
    background-image: url('${img576}');
  }

  @media screen and (min-width: 768px) {
    background-image: url('${img768}');
    background-position-y: top;
    background-position-x: 250px;
    padding: 100px 0;
    height: 530px;
  }

  @media screen and (min-width: 992px) {
    background-position-x: right;
    background-image: url('${img992}');
  }

  @media screen and (min-width: 1280px) {
    background-image: url('${img1280}');
    background-position-x: calc(50% + 200px);
  }
`;

const Stats = () => {
  const { i18n } = useTranslation('sellCar');

  return (
    <StyledWrapper>
      <div className="price-wrapper container">
        {Array.from({ length: 3 }).map((_, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={idx}>
            {i18n.exists(`sellCar.stats.content${idx + 1}.textAbove`) && (
              <div className="price-text">
                <Trans ns="sellCar" i18nKey={`sellCar.stats.content${idx + 1}.textAbove`} components={{ br: <br /> }} />
              </div>
            )}
            <div className="price-amount">
              <Trans
                ns="sellCar"
                i18nKey={`sellCar.stats.content${idx + 1}.amount`}
                components={{ br: <br />, span: <span /> }}
              />
            </div>
            <div className="price-text">
              <Trans ns="sellCar" i18nKey={`sellCar.stats.content${idx + 1}.text`} components={{ br: <br /> }} />
            </div>
          </div>
        ))}
      </div>
    </StyledWrapper>
  );
};

export default Stats;
